import { render, staticRenderFns } from "./VeterinaryLaboratoryTest.vue?vue&type=template&id=292ab80a&scoped=true"
import script from "./VeterinaryLaboratoryTest.vue?vue&type=script&lang=js"
export * from "./VeterinaryLaboratoryTest.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryLaboratoryTest.vue?vue&type=style&index=0&id=292ab80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ab80a",
  null
  
)

export default component.exports